import {
  Box,
  Flex,
  Text,
  IconButton,
  useColorModeValue,
  useDisclosure,
  HStack,
  Button,
  useBoolean,
} from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
import {
  BackIcon,
  CodeQuickIcon,
  SheetEyeIcon
} from '../../../constants/IconData';
import AppColors from '../../../constants/AppColors';
import { FONT_FAMILY } from '../../../constants/Theme';
import { useNavigate } from 'react-router-dom';
import { useContext, useState } from 'react';
import { AuditSheetContext } from '../../../providers/AuditSheetProvider';
import { format } from 'date-fns';
import AuditSheetFileViewer from './AuditSheetFileViewer';
import NotesDrawer from './NotesDrawer';
import ROUTES from '../../../constants/Routes';
import AuditSheetFormViewer from './AuditSheetFormViewer';
import AuditSheetHelpModal from './AuditSheetHelpModal';
import BatchFileViewer from '../../../components/pdf_viewer/BatchFileViewer';
import { getDocumentViewerPath } from '../../../components/pdf_viewer/documentViewer.utils';

export default function Topbar({ 
  onAuditSubmit, 
  sheet, 
  updateAuditSheet, 
  view,
  batchName,
  batchId, 
  disableSubmit, 
  lastSaved, 
  onChange, 
  onOpenNotes, 
  notesDrawerRef 
}) {
  const navigate = useNavigate();
  const auditSheetContext = useContext(AuditSheetContext)
  const { currentUpload } = auditSheetContext
  const { isOpen, onToggle } = useDisclosure();

  const [batchFileData, setBatchFileData] = useState(null);
  const [isModalOpen, imoState] = useBoolean(false);

  const handleOpenBatchViewer = async () => {
    if (batchFileData) { imoState.on(); return; }  // already fetched, reuse same reference
    try {
      imoState.on();
      const res = await auditSheetContext.getFileObjectByBatchId(batchId);
      setBatchFileData(res);
    } catch (error) {
      console.error("Error fetching batch files: ", error);
      imoState.off();
    } finally {
    }
  };

  return (
    <Box w={'100%'}>
      <Flex
        bg={AppColors.secondary}
        color={useColorModeValue('gray.600', 'white')}
        minH={'60px'}
        borderBottom={1}
        borderStyle={'solid'}
        borderColor={useColorModeValue('gray.200', 'gray.900')}
        align={'center'}
      // position='relative'
      >
        <Flex
          flex={{ base: 1, md: 'auto' }}
          ml={{ base: -2 }}
          display={{ base: 'flex', md: 'none' }}
        >
          <IconButton
            onClick={onToggle}
            icon={
              isOpen ? <CloseIcon w={3} h={3} /> : <HamburgerIcon w={5} h={5} />
            }
            variant={'ghost'}
            aria-label={'Toggle Navigation'}
          />
        </Flex>
        <Flex paddingLeft={5} flex={{ base: 1 }} alignItems={'center'}>
          <CodeQuickIcon onClick={()=>navigate(ROUTES.ASSIGN_AUDITS_V2)}  style={{ height: 40,cursor:"pointer" }} />
          <BackIcon style={{ marginLeft: 20, width: 40, height: 40, cursor: 'pointer', display: 'inline-block' }}
            onClick={async () => {
              if (!view) {
                onChange(true);
                try {
                  if (!(await updateAuditSheet())) return;
                } finally {
                  onChange(false);
                }
              }
              navigate(-1)
            }} />
          <Text
            display={{ base: 'none', md: 'block' }}
            color={'white'}
            fontSize={'xl'}
            fontWeight={'bold'}
            mx={7}
          >
            {batchId ? (batchName || batchId) : currentUpload.upload_id}
          </Text>
          {currentUpload.status === 'REBUTTAL IN PROGRESS' && (
            <Box px={3} py={1} borderRadius='md' bg='rgba(251,188,4,0.9)' border='1px solid rgba(255,255,255,0.3)'>
              <Text fontSize='xs' fontWeight='semibold' color='white' whiteSpace='nowrap'>
                Rebuttal In Progress
              </Text>
            </Box>
          )}
        </Flex>

        <HStack alignItems={'center'} spacing={2} gap={2} mr={1}>
          <Text fontSize={'sm'} fontFamily={FONT_FAMILY.ptSans} color={'white'} fontWeight='bold'>
            {lastSaved ? ` Last saved ${format(new Date(lastSaved), 'MMM dd, yyyy')} at ${format(new Date(lastSaved), 'p')}` : null}
          </Text>
          {!view && <AuditSheetFormViewer auditData={currentUpload} sheet={sheet} updateAuditSheet={updateAuditSheet} />}
          {/* <AuditSheetFileViewer auditData={currentUpload} chart_id={currentUpload?.id}/> */}
          {Object.keys(currentUpload).length ? (
                      <AuditSheetFileViewer auditData={currentUpload} chart_id={currentUpload?.id}/>
                    ) : (
                      <SheetEyeIcon
                        style={{ cursor: 'pointer', height: 40, width: 40 }}
                        onClick={handleOpenBatchViewer}
                      />
                    )}
          <NotesDrawer onOpenNotes={onOpenNotes} drawerRef={notesDrawerRef} />
          <Button
            color={'white'}
            style={{ paddingInline: '20px', outlineColor: AppColors.secondary }}
            borderRadius="3xl"
            bgColor={AppColors.yellowColor}
            fontSize={'sm'}
            onClick={onAuditSubmit}
            disabled={view || disableSubmit}
          >
            Submit Audit
          </Button>
          {!view && <AuditSheetHelpModal />}
        </HStack>
      </Flex>
      <BatchFileViewer
        isOpen={isModalOpen}
        onClose={imoState.off}
        batchFiles={batchFileData ?? []}
        viewerPath={getDocumentViewerPath({ batchId })}
      />
    </Box >
  );
}
